import React from "react";
import classNames from "classnames";
import ReactMarkdown from "react-markdown";

export default function InfoMessageComponent(props: {
	type?:
		| "default"
		| "danger"
		| "warning"
		| "note"
		| "success"
		| "empty"
		| "ghost";
	size?: "base" | "sml" | "tny";
	hasBorder?: boolean;
	message?: string;
	addClassName?: string;
	textClass?: string;
	customIcon?: string;
	emptyIcon?: string;
	isMarkdown?: boolean;
	customComponent?: JSX.Element;
}) {
	const {
		type,
		hasBorder = true,
		textClass,
		size,
		message,
		addClassName,
		customIcon,
		emptyIcon,
		isMarkdown,
		customComponent,
	} = props;

	// Classes for empty state

	const emptyWrapperClasses = classNames("card--empty", addClassName);

	const emptyIconClasses = classNames(
		"card--empty__icon u-icon",
		{
			"u-icon--huge": size === undefined || size === "base",
			"u-icon--lrg": size === "sml" || size === "tny",
		},
		"u-icon--empty",
		emptyIcon
	);

	if (type === "empty") {
		return (
			<div className={emptyWrapperClasses}>
				<div className="card--empty__content">
					{emptyIcon !== undefined && (
						<i className={emptyIconClasses} />
					)}
					<div
						className={classNames(
							"card--empty__message",
							textClass
						)}
					>
						{message}
					</div>
				</div>
			</div>
		);
	}

	// Classes for info messages

	const messageTypeClasses = classNames(
		"message",
		{
			"message--base": size === undefined || size === "base",
			[`message--${size}`]: size !== undefined && size !== "base",
			[`message--${type}`]: type !== undefined,
			"message--borderless": !hasBorder,
		},
		addClassName
	);

	const messageIconClasses = classNames(
		"message__icon u-icon",
		{
			"u-icon--lrg":
				(size === undefined || size === "base") &&
				(!customIcon || customIcon === undefined),
			"u-icon--big":
				(size === "sml" || size === "tny") &&
				(!customIcon || customIcon === undefined),
			"u-icon--remove-circle u-color--sent--danger":
				type === "danger" && (!customIcon || customIcon === undefined),
			"u-icon--alert-circle u-color--sent--warning":
				type === "warning" && (!customIcon || customIcon === undefined),
			"u-icon--info-circle u-color--sent--note":
				type === "note" && (!customIcon || customIcon === undefined),
			"u-icon--check-circle u-color--sent--success":
				type === "success" && (!customIcon || customIcon === undefined),
		},
		customIcon
	);

	const messageContentClasses = classNames("message__content", {
		[`message--${type}__content`]: type === "ghost",
	});

	if (isMarkdown) {
		return (
			<div className={messageTypeClasses}>
				{type !== undefined && <i className={messageIconClasses} />}
				<div className={messageContentClasses}>
					<div className={classNames(textClass || "message__text")}>
						<ReactMarkdown className="u-anchor--nested">
							{message as string}
						</ReactMarkdown>
					</div>
				</div>
			</div>
		);
	}

	if (customComponent) {
		return (
			<div className={messageTypeClasses}>
				{type !== undefined && <i className={messageIconClasses} />}

				<div className={messageContentClasses}>
					<div className={classNames(textClass || "message__text")}>
						{message}
					</div>
					{customComponent}
				</div>
			</div>
		);
	}

	return (
		<div className={messageTypeClasses}>
			{type !== undefined && <i className={messageIconClasses} />}

			<div className={messageContentClasses}>
				<div className={classNames(textClass || "message__text")}>
					{message}
				</div>
			</div>
		</div>
	);
}
